import Alert from "components/Alert";
import { IAlertProps } from "components/Alert/Alert.interface";
import { Button } from "components/Button/Button.styled";
import GradesTable from "components/GradesTable";
import { Layout } from "components/Layout/Layout.styled";
import Table from "components/Table";
import { Paragraph, Subtitle, Title } from "components/Text";
import {
  IConsultor,
  IConsultorProyectoData,
} from "constants/interfaces/consultor.interface";
import {
  descargarPDF,
  getConsultorDataById,
  getProyectosConsultor,
} from "helpers/Consultores";
import React, { useCallback, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ProfileContainer = styled.div`
  position: sticky;
  top: 30px;

  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    top: 0;
  }
`;

const ConsultorDetalle = () => {
  const [alert, setAlert] = useState<IAlertProps>({
    title: "",
    icon: "",
    onClose: () => setAlert({ ...alert, show: false }),
    show: false,
    message: "",
    type: "success",
  });
  const [consultorData, setConsultorData] = useState<IConsultor>(null);
  const [proyectosConsultor, setProyectosConsultor] =
    useState<IConsultorProyectoData[]>(null);
  const [isCopied, setIsCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  const pathParts = window.location.pathname.split("/");
  const id = pathParts[pathParts.length - 1];

  const handleGetConsultorData = async () => {
    setLoading(true);
    try {
      const consultorDataResponse = await getConsultorDataById(id);
      return consultorDataResponse;
    } catch (error: any) {
      setAlert({
        ...alert,
        show: true,
        title: "Error",
        message: "Ha ocurrido un error al obtener los datos del consultor",
        type: "danger",
        icon: "cl-close",
      });
      return null;
    } finally {
      setLoading(false);
    }
  };

  const handleGetProyectosConsultor = async (
    rut: string
  ): Promise<IConsultorProyectoData[]> => {
    setLoading(true);
    try {
      const response = await getProyectosConsultor(rut);
      return response;
    } catch (error: any) {
      if (error.status !== 404) {
        setAlert({
          ...alert,
          show: true,
          title: "Error",
          message:
            "Ha ocurrido un error al obtener los proyectos del consultor",
          type: "danger",
          icon: "cl-close",
        });
      }
      return null;
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPDF = async (IdPersona: string) => {
    setLoading(true);
    try {
      await descargarPDF(IdPersona);
    } catch (error: any) {
      if(error.status !== 404)
      {
        setAlert({
          ...alert,
          show: true,
          title: "Error",
          message: "Ha ocurrido un error al descargar el PDF",
          type: "danger",
          icon: "cl-close",
        });

      }
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    handleGetConsultorData().then((data) => {
      setConsultorData(data);
      const rut = data?.Rut?.split("-")[0];
      if (rut) {
        handleGetProyectosConsultor(rut).then((proyectosData) => {
          setProyectosConsultor(proyectosData);
        });
      } else {
        setProyectosConsultor(null);
      }
    });
  }, []);

  const getCelular = (celular: string) => {
    if (!celular) return <Paragraph>No especificado</Paragraph>;

    celular = celular.replace(/\s/g, "");

    return celular.length > 0 ? (
      <a href={`tel:${celular}`}>
        <Paragraph> {celular.match(/.{2,4}/g)?.join(" ")}</Paragraph>
      </a>
    ) : (
      <Paragraph>No especificado</Paragraph>
    );
  };

  const columns = [
    "Año Resolucion Concurso",
    "Total Proyectos Postulados",
    "Proyectos Seleccionados",
    "Proyectos No Seleccionados",
    "Proyectos Admitidos",
    "Proyectos No Admitidos",
    "Proyectos Retirados",
  ];

  return (
    <Layout className="pt-5">
      <div className="container">
        <Alert {...alert} />
        <div className="row align-items-center">
          <div className="col-1 mr-5">
            <Button
              className="btn btn-link"
              onClick={() => window.history.back()}
            >
              <i className="cl cl-arrow-left"></i>
            </Button>
          </div>
          <div className="col">
            <div className="row align-items-center">
              {loading ? (
                <Skeleton width={200} />
              ) : (
                <Title className="mr-3">
                  {consultorData?.Nombre} {consultorData?.ApPaterno || ""} {consultorData?.ApMaterno || ""}
                </Title>
              )}
            </div>
          </div>
        </div>
        <hr className="divider" />
        <div className="profile-page">
          <div className="profile-group">
            <ProfileContainer>
              <div className="profile-header">
                <section className="section">
                  <div className="section-header">
                    <Subtitle className="pb-2 border-bottom border-accent">
                      Información de contacto
                    </Subtitle>
                  </div>
                  <div className="section-body">
                    <Paragraph className="mb-4">
                      Contacto:{" "}
                      {loading ? (
                        <Skeleton width={150} />
                      ) : (
                        getCelular(
                          consultorData?.Celular[
                            consultorData?.Celular.length - 1
                          ]
                        ) || "No especificado"
                      )}
                    </Paragraph>
                    {consultorData?.Correo &&
                      consultorData?.Correo.length > 0 && (
                        <Button
                          className="btn btn-primary btn-block mt-3"
                          onClick={() => {
                            window.location.href = `mailto:${
                              consultorData?.Correo[
                                consultorData.Correo.length - 1
                              ]
                            }`;
                          }}
                        >
                          Contacta este perfil
                        </Button>
                      )}
                  </div>
                </section>
              </div>
              {/* [INICIO] BOTON DE DESCARGA PDF */}
              <div className="pdf-download">
                <section>
                  <div className="section-header">
                    <Subtitle className="pb-2 border-bottom border-accent ml-3 mt-3">
                      Descargar PDF
                    </Subtitle>
                  </div>
                  <div className="section-body mb-3">
                  <Button
                    className="btn btn-primary btn-block ml-3"
                    onClick={() => handleDownloadPDF(String(consultorData.PersonaID))}
                    disabled={loading}
                  >
                    {loading ? "Descargando..." : "Detalle Consultor PDF"}
                  </Button>
                  </div>
                </section>
              </div>
              {/* [FIN] BOTON DE DESCARGA PDF */}
              <div className="profile-footer">
                <section className="section">
                  <div className="section-header">
                    <Subtitle className="pb-2 border-bottom border-accent">
                      Comparte en esta página
                    </Subtitle>
                  </div>
                  <div className="section-body mb-5">
                    <q>
                      <Paragraph>A través de:</Paragraph>
                      <div className="row container">
                        <Button
                          className="btn link-icon"
                          onClick={(e) => {
                            e.preventDefault();
                            setIsCopied(true);
                            setTimeout(() => {
                              setIsCopied(false);
                            }, 3000);
                            navigator.clipboard.writeText(window.location.href);
                          }}
                        >
                          <i className="cl cl-document-verified mr-2"></i>
                          {isCopied ? "Enlace copiado!" : "Copiar enlace"}
                        </Button>
                      </div>
                    </q>
                  </div>
                </section>
              </div>
            </ProfileContainer>
          </div>
          <div className="profile-body my-4">
            <section className="section">
              <div className="section-header">
                <Subtitle className="pb-2 border-bottom border-accent">
                  Detalle de consultor
                </Subtitle>
              </div>
              <div className="section-body">
                <div className="row">
                  <div className="col">
                    <Subtitle>Nro. Registro</Subtitle>
                    <Paragraph>
                      {loading ? (
                        <Skeleton width={100} />
                      ) : (
                        consultorData?.NroRegistro || "No especificado"
                      )}
                    </Paragraph>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <Subtitle>Profesión</Subtitle>
                    <Paragraph>
                      {loading ? (
                        <Skeleton width={100} />
                      ) : (
                        consultorData?.Profesion || "No especificado"
                      )}
                    </Paragraph>
                  </div>
                  <div className="col">
                    <Subtitle>Estado</Subtitle>
                    <Paragraph>
                      {loading ? (
                        <Skeleton width={100} />
                      ) : consultorData?.Vigente === 1 ? (
                        "Vigente"
                      ) : (
                        "No Vigente"
                      )}
                    </Paragraph>
                  </div>
                  <div className="col">
                    <Subtitle>Género</Subtitle>
                    <Paragraph>
                      {loading ? (
                        <Skeleton width={100} />
                      ) : (
                        consultorData?.Genero || "No especificado"
                      )}
                    </Paragraph>
                  </div>
                </div>
              </div>
              <div className="section-header">
                <Subtitle className="mt-2 border-bottom border-accent">
                  Proyectos
                </Subtitle>
              </div>
              <div className="section-body">
                {loading ? (
                  <Skeleton count={5} height={30} />
                ) : (
                  <>
                    {proyectosConsultor !== null ? (
                      <Table data={proyectosConsultor} columns={columns} />
                    ) : (
                      <Paragraph>Sin Datos</Paragraph>
                    )}
                  </>
                )}
              </div>

              <div className="section-header">
                <Subtitle className="mt-2 border-bottom border-accent">
                  Especialidades
                </Subtitle>
              </div>
              <div className="section-body">
                <div className="row">
                  {loading ? (
                    <Skeleton count={3} width={100} />
                  ) : consultorData?.Especialidades &&
                    consultorData?.Especialidades.length > 0 ? (
                    consultorData?.Especialidades.map((especialidad, index) => (
                      <div className="col-auto pb-3" key={index}>
                        <div className="badge badge-success font-level-7">
                          {especialidad}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-auto pb-3">
                      <div className="badge badge-success font-level-7">
                        Sin datos
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="section-header">
                <Subtitle className="mt-2 border-bottom border-accent">
                  Evaluación de desempeño
                </Subtitle>
              </div>
              <div className="section-body">
                {loading ? (
                  <Skeleton count={5} height={30} />
                ) : (
                  (() => {
                    if (!consultorData) {
                      return (
                        <div className="text-center my-5">
                          <Spinner animation="border" />
                        </div>
                      );
                    }
                    if (consultorData.Calificaciones.length > 0) {
                      return <GradesTable consultorData={consultorData} />;
                    }
                    return <Paragraph>Sin datos</Paragraph>;
                  })()
                )}
              </div>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ConsultorDetalle;
